import { envVars } from '../../helpers';

export const SEARCH_API_URL = envVars(
  'NEXT_PUBLIC_SCORENCO_SEARCH_URL',
  process.env.NEXT_PUBLIC_SCORENCO_SEARCH_URL
)
  .modify((val) => val || 'https://search.scorenco.com')
  .asString();
